import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { ICreateTradePricingProposalRequest } from '../interface/trade/pricing/proposal/ICreateTradePricingProposalRequest';
import { TradePhaseEnum } from '../enum/TradePhaseEnum';

enum TradePricingProposalServiceEnum {
  base = "/",
  existsByTradeId = "/exists",
  getProposalAllowedPhases = "/allowed-phases"
}

export default class TradePricingProposalService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/trade/pricing/proposal");
  }

  public create = async (data: ICreateTradePricingProposalRequest) => await this.POST(TradePricingProposalServiceEnum.base, data);
  public existsByTradeId = async (tradeId: number) => await this.GET(`${TradePricingProposalServiceEnum.existsByTradeId}/${tradeId}`);
  public getProposalAllowedPhases = async (): Promise<TradePhaseEnum[]> => await this.GET(`${TradePricingProposalServiceEnum.getProposalAllowedPhases}`);
}
